module.exports = __webpack_public_path__ + "static/media/018.b290b331.jpg";